var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydataIconBannerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM7.03033 3.96967C6.73744 3.67678 6.26256 3.67678 5.96967 3.96967C5.67678 4.26256 5.67678 4.73744 5.96967 5.03033L8.43934 7.5L5.96967 9.96967C5.67678 10.2626 5.67678 10.7374 5.96967 11.0303C6.26256 11.3232 6.73744 11.3232 7.03033 11.0303L9.67678 8.38388C10.1649 7.89573 10.1649 7.10427 9.67678 6.61612L7.03033 3.96967Z"
  })));
}
export default SvgMydataIconBannerArrow;